"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setProps = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _m = require("@mutant-ws/m");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var setProps = function setProps(props) {
  return function (_ref) {
    var baseURL = _ref.baseURL,
        headers = _ref.headers,
        queryStringifyFn = _ref.queryStringifyFn;

    if ((0, _m.is)(queryStringifyFn)) {
      if (typeof queryStringifyFn === "function") {
        props.queryStringifyFn = queryStringifyFn;
      } else {
        throw new TypeError("@mutant-ws/fetch-browser: \"queryStringifyFn\" should be a function, received ".concat(JSON.stringify(queryStringifyFn)));
      }
    }

    if ((0, _m.is)(headers)) {
      if ((0, _m.isObject)(headers)) {
        props.headers = _objectSpread(_objectSpread({}, props.headers), headers);
      } else {
        throw new TypeError("@mutant-ws/fetch-browser: \"headers\" should be an object, received ".concat(JSON.stringify(headers)));
      }
    }

    if ((0, _m.is)(baseURL)) {
      if (typeof baseURL === "string") {
        props.baseURL = (0, _m.trim)("/")(baseURL);
      } else {
        throw new TypeError("@mutant-ws/fetch-browser: \"baseURL\" should be a string, received ".concat(JSON.stringify(baseURL)));
      }
    }
  };
};

exports.setProps = setProps;